<template>
  <div class="rt-table-list">
    <div class="header">
      <el-tabs v-model="activeName" @tab-click="handleTabClick">
        <el-tab-pane name="first">
          <span slot="label">
             <div class="warp-title">
                <img src="@/assets/img/icon07.png" style="width: 20px; margin-right: 5px;"/>
                出场车辆
              </div>
          </span>
        </el-tab-pane>
        <el-tab-pane name="second">
          <span slot="label">
             <div class="warp-title">
                <img src="@/assets/img/icon20.png" style="width: 20px; margin-right: 5px;"/>
                相机识别未开闸记录
              </div>
          </span>
        </el-tab-pane>
      </el-tabs>
      <el-input
        class="item34"
        placeholder="搜索车牌"
        v-model="searchStr"
        style="width: 200px;"
      >
        <i slot="suffix" class="el-input__icon el-icon-search" style="color: #5E7FEC;" @click="init"></i>
      </el-input>
    </div>
    <el-table
      ref="orderData"
      :data="orderData"
      key="orderData"
      style="width: 100%"
      :height="233"
      :row-class-name="tableRowClassName"
      :cell-class-name="tableCellStyle"
      v-show="activeName === 'first'"
    >
      <el-table-column prop="passInPlateImage" label="凭证" align="center" width="100">
        <template slot-scope="scope">
          <el-image
            class="img"
            lazy
            :src="scope.row.passPlateImage"
            fit="fill"
            :preview-src-list="scope.row.passPlateImageArr"
          >
            <div slot="placeholder" class="image-slot">
              加载中<span class="dot">...</span>
            </div>
            <div slot="error" class="image-slot">
              暂无图片
            </div>
          </el-image>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="车牌号"
        width="120"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span style="font-size: 16px; font-weight: bold;">{{scope.row.plateNumber}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="payableAmount" label="收费金额">
        <template slot-scope="scope">
          <img src="@/assets/img/img09.png" style="width: 24px; margin-bottom: -6px;" v-if="scope.row.payableAmount === 0 || scope.row.payableAmount === '0.00'"/>
          <span v-else>{{scope.row.payableAmount}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="车类" show-overflow-tooltip>
        <template slot-scope="scope">
          <span :style="{color: scope.row.carTypeStr === '月卡车' ? '#5E7FEC' : '#606266'}">{{scope.row.carTypeStr}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="carSize" label="车型" align="center">
        <template slot-scope="scope">
          <div>{{showCarSizeTable(scope.row.carSize)}}</div>
        </template>
      </el-table-column>
      <!--
      <el-table-column align="center" label="方向">
        <template slot-scope="scope">
          {{ !!scope.row.leftAt ? "出场" : "入场" }}
        </template>
      </el-table-column>-->
      <el-table-column align="center" label="出场时间" show-overflow-tooltip>
        <template slot-scope="scope">
          {{ !!scope.row.leftAt ? scope.row.leftAt : scope.row.cameAt }}
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="parkingLength"
        label="停车时长"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="remark"
        label="支付方式"
        show-overflow-tooltip
      >
      </el-table-column>
    </el-table>
    <el-table
      ref="openGateFailedRecord"
      :data="openGateFailedRecord"
      key="openGateFailedRecord"
      style="width: 100%"
      :height="233"
      :row-class-name="tableRowClassName"
      :cell-class-name="tableCellStyle"
      v-show="activeName === 'second'"
    >
      <el-table-column prop="passInPlateImage" label="识别图片" align="center" width="100">
        <template slot-scope="scope">
          <el-image
            class="img"
            lazy
            :src="scope.row.FullImage"
            fit="fill"
            :preview-src-list="scope.row.FullImageArr"
          >
            <div slot="placeholder" class="image-slot">
              加载中<span class="dot">...</span>
            </div>
            <div slot="error" class="image-slot">
              暂无图片
            </div>
          </el-image>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="车牌号"
        width="120"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span style="font-size: 16px; font-weight: bold;">{{scope.row.PlateNumber}}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="停车场名称"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          {{scope.row.ParkLotName}}
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="出入口名称"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          {{scope.row.ParkLotGateName}}
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="识别时间"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          {{scope.row.CreatedAt}}
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="备注"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          {{scope.row.Description}}
        </template>
      </el-table-column>
    </el-table>
    <page-size ref="page" @pageChange="init" />
    <!--
    <span @click="$store.dispatch('ToggleCollaps')"
      ><img v-if="!isCollaps" src="@/assets/img/expand.png" /><img
        v-else
        src="@/assets/img/collaps.png"
    /></span>-->
  </div>
</template>

<script>
import pageSize from "@/components/PageSize/index";
import { queryParkOrder, billCarSize, queryOpenGateFailedRecord } from "@/api/module/tenant";
// import { parkOutPubSub } from "@/service/pubsub/index";
import { realOutListPubSub } from "@/service/pubsub/index";
import parkMix from "@/minxs/parkLotId";

export default {
  components: {
    pageSize,
  },
  data() {
    return {
      plateColorArr: [],
      orderId: "",
      orderData: [],
      time: null,
      searchStr: '',
      activeName: 'first',
      openGateFailedRecord: [],
    };
  },
  mixins: [parkMix],
  props: {
    isCollaps: Boolean,
  },
  mounted() {
    this.init();
    this.getCarSize();
    this.$nextTick(() => {
      realOutListPubSub.subscribe(this.queryOrder);
    //   this.refreshData();
    });
  },
  watch: {
    $route: {
      handler: function(){
        this.init();
        this.getCarSize();
      },
      deep: true
    }
  },
  methods: {
    async init() {
      this.orderData = [];
      this.openGateFailedRecord = [];
      const $page = this.$refs.page;
      let res, param = {
        Page: $page ? $page.current : 1,
        PerPage: $page ? $page.pageSize : 5,
        ParkLotId: this.ParkLotId,
        PlateNumber: this.searchStr,
      };
      if (this.activeName === 'first') {
        let obj = Object.assign(
          {
            orderType: "全部",
            IsLimitDate: 1,
            IsLeft: 1,
            SentryBoxId: Number(sessionStorage.getItem("sentryId")),
            SortType: 1,
            GateQuery: true,
          }, param);
        res = await queryParkOrder(obj);
      } else {
        res = await queryOpenGateFailedRecord(param);
      }
      if (res.state === "success") {
        if ($page) $page.total = res.pageInfo.Total;
        if (this.activeName === 'first') {
          this.queryOrder(res.data);
        } else {
          this.queryOrderFail(res.data);
        }
        // console.log(res.data)
      }
    },
    tableRowClassName({ row }) {
      if (row.leftAt) {
        return ''// "green-row";
      }
      return "";
    },
    queryOrder(data){
      if (data.length > 0) {
        this.orderData = data.map(v => {
          v.passPlateImage = v.passInPlateImage === '' ? v.passOutPlateImage : v.passInPlateImage;
          v.passPlateImageArr = [v.passPlateImage];
          return v
        });
        this.$nextTick(() => {
          this.$refs.orderData && this.$refs.orderData.doLayout();
        });
      } else {
        this.orderData = []
      }
    },
    queryOrderFail(data) {
      if (data.length > 0) {
        this.openGateFailedRecord = data.map(v => {
          v.FullImageArr = [v.FullImage];
          v.plateColor = v.PlateColor;
          return v
        });
        this.$nextTick(() => {
          this.$refs.openGateFailedRecord && this.$refs.openGateFailedRecord.doLayout();
        });
      } else {
        this.openGateFailedRecord = []
      }
    },
    refreshData() {
      if (this.time) {
        clearTimeout(this.time);
      }
      this.init();
      this.time = setTimeout(() => {
        this.refreshData();
      }, 30000);
    },
    async getCarSize() {
      let res = await billCarSize();
      if (res.state === "success") {
        this.carSizeTable = res.data;
      } else {
        this.$message.error(res.message);
      }
    },
    tableCellStyle({row, columnIndex}) {
      if(columnIndex === 0){
        return 'imgCell ' + this.array[row.plateColor - 1]
      }
    },
    handleTabClick() {
      const $page = this.$refs.page;
      $page.current = 1;
      this.init();
    },
  },
};
</script>

<style lang="scss" scoped>
.rt-table-list {
  & > span {
    display: flex;
    background: #fff;
    flex-direction: column;
    justify-content: center;
    padding: 0 10px;
    cursor: pointer;
    & img {
      width: 20px;
    }
  }
}
</style>
<style lang="scss">
.green-row {
  color: #091B8F !important;
}
</style>
